import { ActivatedRoute } from '@angular/router';

import { AuthService } from './../../_services/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-study-material-syllabus-index',
  templateUrl: './study-material-syllabus-index.component.html',
  styleUrls: ['./study-material-syllabus-index.component.css']
})
export class StudyMaterialSyllabusIndexComponent implements OnInit {
  server_user_id=0
  constructor(public authService:AuthService,  private route: ActivatedRoute) {

   }

  ngOnInit(): void {
    this.route.params.subscribe(
      p=>{
       this.server_user_id=+p['server_user_id']
      }
    )
  }

}

